"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function HeroIntroduction() {
  const {
    ref: contentRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    once: true
  });
  return <section data-section-id="227835" id="hero" className="relative min-h-[90vh] flex items-center justify-center overflow-hidden bg-background text-foreground">
      {/* Background Navy Gradient */}
      <div className="absolute inset-0" style={{
      background: "linear-gradient(135deg, #0B1F33 0%, #183A55 100%)"
    }} />

      {/* Dark Slate Overlay for Readability */}
      <div className="absolute inset-0 bg-secondary/70 mix-blend-multiply" />

      {/* Subtle Grid Pattern Overlay */}
      <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1579221/img/subtle_overlay_pattern.png)] opacity-10 mix-blend-overlay pointer-events-none" />

      {/* Bottom Gradient Accent */}
      <div className="absolute bottom-0 left-0 right-0 h-3/4 bg-gradient-to-t from-primary/30 via-transparent to-transparent pointer-events-none" />

      {/* Content */}
      <div ref={contentRef} className={`relative z-10 container mx-auto px-4 md:px-6 text-center flex flex-col items-center transition-all duration-1000 ease-out transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
        <h1 className="font-default text-5xl md:text-7xl lg:text-[60px] font-bold text-primary-foreground leading-tight tracking-tighter max-w-5xl drop-shadow-lg">
          Expert Home Inspector in{" "}
          <span className="text-primary drop-shadow-md">Kendall, FL</span>
        </h1>

        <p className="font-default text-lg md:text-xl text-primary-foreground/90 max-w-2xl mt-6 leading-relaxed">
          Comprehensive property inspections for peace of mind. We provide detailed reports and professional service across South Florida.
        </p>

        <Button asChild size="lg" className="mt-10 rounded-md text-lg px-10 py-7 bg-primary hover:bg-primary/90 text-primary-foreground shadow-xl shadow-primary/20 hover:shadow-2xl hover:shadow-primary/40 transition-all duration-300 hover:-translate-y-1">
          <Link to="https://trusted-fl.com/#schedule-your-inspection">
            Schedule Your Inspection
            <ArrowRight className="ml-2 size-5" />
          </Link>
        </Button>
      </div>
    </section>;
}